export class VcTreeConstants {
    private static _ENTITY_TO_QUERY_PARAMETERS_MAP: Object = {
        'vcenter': 'parentType=vcenter&format=tree',
        'folder': 'parentType=folder&format=tree',
        'datacenter': 'entityType=host$folder,host$cluster,host$computeResource&parentType=datacenter&format=tree',
        'cluster': 'entityType=Resources$resourcePool,Resources$vm&parentType=cluster&format=tree',
        'computeResource': 'entityType=Resources$resourcePool,Resources$vm&parentType=computeResource&format=tree',
        'resourcePool': 'entityType=resourcePool,vm&parentType=resourcePool&format=tree'
    };
    public static getChildrenQueryParameters(entity: string): string {
       return VcTreeConstants._ENTITY_TO_QUERY_PARAMETERS_MAP[entity];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/tree-holder/vc-tree-constants.ts